<template>
  <b-tr>
    <!-- species -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(livestock?.species,isFieldInCache(field,year,rowIndex,'species'))"
    >
      <PracticeChoiceDropdown
        clearable
        dense
        hide-details="true"
        :items="speciesChoices"
        item-text="display_name"
        item-value="value"
        v-model="species"
        choiceName="pasture_livestock_species"
        :append-icon="
          livestock.species !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('species', species)"
      />
    </b-td>
    <!-- animal detail -->
    <b-td
      class="cell-table marge-column"
      :class="getClassForCell(livestock?.animal_details,isFieldInCache(field,year,rowIndex,'animal_details'))"
    >
      <PracticeChoiceDropdown
        clearable
        dense
        hide-details="true"
        :items="animalDetailChoices"
        item-text="display_name"
        item-value="value"
        v-model="animalDetail"
        choiceName="pasture_livestock_animal_details"
        :append-icon="
          livestock.animal_details !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('animalDetail', animalDetail)"
      />
    </b-td>
    <!-- average weight -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(livestock?.average_weight,isFieldInCache(field,year,rowIndex,'average_weight'))"
    >
      <v-text-field
        clearable
        dense
        v-model="averageWeight"
        hide-details="true"
        :append-icon="
          livestock.average_weight !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('averageWeight', averageWeight)"
      >
      </v-text-field>
    </b-td>
    <!-- unit -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(livestock?.weight_unit,isFieldInCache(field,year,rowIndex,'weight_unit'))"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="weightUnitChoices"
        item-text="display_name"
        item-value="value"
        v-model="weightUnit"
        :append-icon="
          livestock.weight_unit !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('weightUnit', weightUnit)"
      />
    </b-td>
    <b-td class="cell-table white">
      <v-btn icon x-small color="black" @click="handleAdd">
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
      <v-btn icon x-small color="black" @click="handleDelete" v-if="dataLength > 1">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>.
    </b-td>
  </b-tr>
</template>
<script>
import { mapMutations, mapGetters,mapActions } from "vuex"
import { Defaults } from "@/store/modules"
import { getClassForCell } from "../utils"
import PracticeChoiceDropdown from "@/components/dropdowns/PracticeChoiceDropdown"

export default {
  name: "RanchLivestockRow",
  props: {
    additionView: { type: Boolean, default: false },
    cropId: { type: Number },
    field: { type: String },
    livestock: { type: Object },
    rowIndex: { type: Number },
    dataLength:{ type: Number },
    year: { type: String },
  },
  components: {
    PracticeChoiceDropdown,
  },
  data() {
    return {
      getClassForCell,
    }
  },
  computed: {
    ...mapGetters({
      practiceChoices: Defaults.Getters.getPracticeChoices,
      isFieldInCache: Defaults.Getters.isFieldInCache,
    }),
    speciesChoices() {
      return this.practiceChoices["pasture_livestock_species"]
    },
    animalDetailChoices() {
      return this.practiceChoices["pasture_livestock_animal_details"]
    },
    weightUnitChoices() {
      return this.practiceChoices["pasture_livestock_weight_units"]
    },
    species: {
      get() {
        return this.livestock.species
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "live_stock",
          dataSetting: "species",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    animalDetail: {
      get() {
        return this.livestock.animal_details
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "live_stock",
          dataSetting: "animal_details",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    averageWeight: {
      get() {
        return this.livestock.average_weight
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "live_stock",
          dataSetting: "average_weight",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    weightUnit: {
      get() {
        return this.livestock.weight_unit
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "live_stock",
          dataSetting: "weight_unit",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
  },
  methods: {
    ...mapMutations({
      addFieldSettingRow: Defaults.Mutations.addFieldSettingRow,
      deleteNewFieldSetting: Defaults.Mutations.deleteNewFieldSetting,
      updateNewFieldSetting: Defaults.Mutations.updateNewFieldSetting,
      spreadsheetMutate: Defaults.Mutations.spreadsheetMutate,

    }),
    ...mapActions({
      spreadsheetUpdate: Defaults.Actions.spreadsheetUpdate,
    }),
    
    // typesByMethod(method, existingType) {
    //   if (["IPM", "IWM", "IDM"].includes(method)) {
    //     return this.typeChoices.filter(
    //       c => c.dependent_value === method || c.value === "other"
    //     )
    //   }
    //   return this.typeChoices.filter(
    //       c => c.dependent_value === method || !c.dependent_value
    //   )
    // },
    // unitsByMethod(method) {
    //   return this.unitChoices.filter(
    //     c => c.dependent_value === method || !c.dependent_value
    //   )
    // },
    // cropProtectionChoices(method, type) {
    //   const choices = cropProtectionChoices(method, type)
    //   return choices
    // },
    handleClickSubmit(setting, val) {
      this[setting] = val
    },
    handleCopy() {
      this.$emit("handle-copy", this.livestock)
    },
    handleAdd() {
      const payloadObj = {
        crop_id: this.cropId ,
        species: null,
        animal_details: null,
        average_weight: null,
        weight_unit: null,
        year:this.year,
        defaults_template:this.livestock.defaults_template,
      }
      this.addFieldSettingRow({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "live_stock",
        dataObj: payloadObj,
        year: this.year,
      })
    },
    handleDelete() {
      
      this.deleteNewFieldSetting({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "live_stock",
        recordId: this.livestock.id,
        rowIndex: this.rowIndex,
        year: this.year,
      })
    },
    handleValidateValue(val, type, length = 24) {
      function isNumeric(val) {
        return !isNaN(val) && !isNaN(parseFloat(val));
      }

      if (val === null) {
        return true
      }

      if (val.length > length) {
        this.$emit(
          "bad-input",
          "Inputted value length was too long (24 characters allowed)."
        )
        return false
      }

      if (type == "number") {
        if (isNumeric(val)) {
          return true
        } else {
          this.$emit(
            "bad-input",
            "Look out! A numerical value is expected here."
          )
          return false
        }
      } else if (type == "string") {
        return true
      }
    },
    filter(event) {
      event = event ? event : window.event
      let expect = event.target.value.toString() + event.key.toString()

      let validVal = this.handleValidateValue(expect, "number", 24)
      if (!validVal) event.preventDefault()
    },
  },
}
</script>
<style scoped>
.arva-alert {
  background-color: #f7c0be;
}

.cell-table {
  padding: 2px 6px;
}

.pre-gen {
  background-color: #fedb80;
}

.bg-white {
  color: white;
}

.cell-text {
  font-weight: 600;
  color: white;
}

.machine {
  background-color: #c0dce2;
}

.complete {
  background-color: #c7e3c1;
}

.copy-icon {
  cursor: pointer;
  color: #0f9aee;
}

.delete {
  color: #cc0101;
  cursor: pointer;
}

.input-check {
  cursor: pointer;
}

.select-check {
  margin-top: 14px;
  cursor: pointer;
}

.submit-icon {
  color: #c7e3c1;
}

.medium-column {
  width: 140px;
  max-width: 140px;
}

.large-column {
  width: 240px;
  max-width: 240px;
}

.marge-column {
  width: 180px;
  max-width: 180px;
}

.v-input {
  font-size: 18px;
}
</style>
